import React, { useState } from 'react';

import { QRCodeSVG } from 'qrcode.react';
import { Share2 } from 'react-feather';
import { useSelector } from 'react-redux';

import styles from './ShareRefCodeButton.module.scss';

/**
 * Displays the customer's own shareable referral code with a copy/share
 * button — used on MyAccount and the post-signup referral screens.
 *
 * ASSUMPTION (flagged, not verified): reads the code from
 * `customerProfile.data.referral_code`. No customer-facing referral-code
 * field was visible anywhere in the redux I was given (customerProfile's
 * duck is just an initial-state shell — the real API response shape isn't
 * visible from the duck alone). This mirrors the business-side equivalent
 * (Dashboard.js's ShareReferralCode component, which reads
 * `businessReferralProgram.data.referral_code`) — same pattern, customer
 * side. Verify the actual field name against the real API response.
 *
 * Uses the Web Share API where available (mobile browsers, some desktop),
 * falling back to clipboard copy everywhere else.
 */
const ShareRefCodeButton = () => {
  const referralCode = useSelector(state => state.customerProfile?.data?.referral_code);
  const [copied, setCopied] = useState(false);

  const shareUrl = referralCode ? `https://mycouponbook.ca/signup?ref=${referralCode}` : null;

  const handleShare = async () => {
    if (!shareUrl) return;

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Join me on My Couponbook',
          text: `Use my referral code ${referralCode} to get started on My Couponbook!`,
          url: shareUrl,
        });
        return;
      } catch (err) {
        // User cancelled the native share sheet, or it failed — fall through
        // to clipboard copy below.
      }
    }

    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (err) {
      console.warn('Could not copy referral link to clipboard', err);
    }
  };

  if (!referralCode) return null;

  return (
    <div className={styles.wrap}>
      <div className={styles.qrWrap}>
        <QRCodeSVG value={shareUrl} size={160} />
      </div>
      {/* <div className={styles.codeRow}>
        <span className={styles.codeText}>{referralCode}</span>
      </div> */}
      <button type="button" className={copied ? `${styles.shareBtn} ${styles.copied}` : styles.shareBtn} onClick={handleShare}>
        <span className={styles.shareBtnInner}>
          <Share2 size={16} className={styles.shareBtnIcon} />
          <span className={styles.shareBtnLabel}>{copied ? 'Link Copied!' : 'Share My Code'}</span>
        </span>
      </button>
    </div>
  );
};

export default ShareRefCodeButton;